/* eslint-disable */
// this is an auto generated file. This will be overwritten

export const getUserAnswer = /* GraphQL */ `
  query GetUserAnswer($id: ID!) {
    getUserAnswer(id: $id) {
      id
      userId
      answers
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const listUserAnswers = /* GraphQL */ `
  query ListUserAnswers(
    $id: ID
    $filter: ModelUserAnswerFilterInput
    $limit: Int
    $nextToken: String
    $sortDirection: ModelSortDirection
  ) {
    listUserAnswers(
      id: $id
      filter: $filter
      limit: $limit
      nextToken: $nextToken
      sortDirection: $sortDirection
    ) {
      items {
        id
        userId
        answers
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const getMedicalQuizResult = /* GraphQL */ `
  query GetMedicalQuizResult($id: ID!) {
    getMedicalQuizResult(id: $id) {
      id
      userId
      bestMatches
      worstMatches
      domainScores
      createdAt
      updatedAt
      owner
      __typename
    }
  }
`;
export const listMedicalQuizResults = /* GraphQL */ `
  query ListMedicalQuizResults(
    $id: ID
    $filter: ModelMedicalQuizResultFilterInput
    $limit: Int
    $nextToken: String
    $sortDirection: ModelSortDirection
  ) {
    listMedicalQuizResults(
      id: $id
      filter: $filter
      limit: $limit
      nextToken: $nextToken
      sortDirection: $sortDirection
    ) {
      items {
        id
        userId
        bestMatches
        worstMatches
        domainScores
        createdAt
        updatedAt
        owner
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const medicalResultsByUserId = /* GraphQL */ `
  query MedicalResultsByUserId(
    $userId: String!
    $sortDirection: ModelSortDirection
    $filter: ModelMedicalQuizResultFilterInput
    $limit: Int
    $nextToken: String
  ) {
    medicalResultsByUserId(
      userId: $userId
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        userId
        bestMatches
        worstMatches
        domainScores
        createdAt
        updatedAt
        owner
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const medicalResultsByOwner = /* GraphQL */ `
  query MedicalResultsByOwner(
    $owner: String!
    $sortDirection: ModelSortDirection
    $filter: ModelMedicalQuizResultFilterInput
    $limit: Int
    $nextToken: String
  ) {
    medicalResultsByOwner(
      owner: $owner
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        userId
        bestMatches
        worstMatches
        domainScores
        createdAt
        updatedAt
        owner
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const getMBTIQuizResult = /* GraphQL */ `
  query GetMBTIQuizResult($id: ID!) {
    getMBTIQuizResult(id: $id) {
      id
      userId
      personalityType
      recommendedSpecialties
      scoreBreakdown
      createdAt
      updatedAt
      owner
      __typename
    }
  }
`;
export const listMBTIQuizResults = /* GraphQL */ `
  query ListMBTIQuizResults(
    $id: ID
    $filter: ModelMBTIQuizResultFilterInput
    $limit: Int
    $nextToken: String
    $sortDirection: ModelSortDirection
  ) {
    listMBTIQuizResults(
      id: $id
      filter: $filter
      limit: $limit
      nextToken: $nextToken
      sortDirection: $sortDirection
    ) {
      items {
        id
        userId
        personalityType
        recommendedSpecialties
        scoreBreakdown
        createdAt
        updatedAt
        owner
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const mbtiResultsByUserId = /* GraphQL */ `
  query MbtiResultsByUserId(
    $userId: String!
    $sortDirection: ModelSortDirection
    $filter: ModelMBTIQuizResultFilterInput
    $limit: Int
    $nextToken: String
  ) {
    mbtiResultsByUserId(
      userId: $userId
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        userId
        personalityType
        recommendedSpecialties
        scoreBreakdown
        createdAt
        updatedAt
        owner
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const mbtiResultsByOwner = /* GraphQL */ `
  query MbtiResultsByOwner(
    $owner: String!
    $sortDirection: ModelSortDirection
    $filter: ModelMBTIQuizResultFilterInput
    $limit: Int
    $nextToken: String
  ) {
    mbtiResultsByOwner(
      owner: $owner
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        userId
        personalityType
        recommendedSpecialties
        scoreBreakdown
        createdAt
        updatedAt
        owner
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const getUserProfile = /* GraphQL */ `
  query GetUserProfile($id: ID!) {
    getUserProfile(id: $id) {
      id
      name
      email
      username
      yearInMedSchool
      medicalUniversity
      demographics
      chosenSpecialty
      specialtyUpdatedAt
      trainingPath
      owner
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const listUserProfiles = /* GraphQL */ `
  query ListUserProfiles(
    $id: ID
    $filter: ModelUserProfileFilterInput
    $limit: Int
    $nextToken: String
    $sortDirection: ModelSortDirection
  ) {
    listUserProfiles(
      id: $id
      filter: $filter
      limit: $limit
      nextToken: $nextToken
      sortDirection: $sortDirection
    ) {
      items {
        id
        name
        email
        username
        yearInMedSchool
        medicalUniversity
        demographics
        chosenSpecialty
        specialtyUpdatedAt
        trainingPath
        owner
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const profileByEmail = /* GraphQL */ `
  query ProfileByEmail(
    $email: String!
    $sortDirection: ModelSortDirection
    $filter: ModelUserProfileFilterInput
    $limit: Int
    $nextToken: String
  ) {
    profileByEmail(
      email: $email
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        name
        email
        username
        yearInMedSchool
        medicalUniversity
        demographics
        chosenSpecialty
        specialtyUpdatedAt
        trainingPath
        owner
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const profileByOwner = /* GraphQL */ `
  query ProfileByOwner(
    $owner: String!
    $sortDirection: ModelSortDirection
    $filter: ModelUserProfileFilterInput
    $limit: Int
    $nextToken: String
  ) {
    profileByOwner(
      owner: $owner
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        name
        email
        username
        yearInMedSchool
        medicalUniversity
        demographics
        chosenSpecialty
        specialtyUpdatedAt
        trainingPath
        owner
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const getIMTDomainProgress = /* GraphQL */ `
  query GetIMTDomainProgress($id: ID!) {
    getIMTDomainProgress(id: $id) {
      id
      userId
      domainKey
      progress
      createdAt
      updatedAt
      owner
      __typename
    }
  }
`;
export const listIMTDomainProgresses = /* GraphQL */ `
  query ListIMTDomainProgresses(
    $id: ID
    $filter: ModelIMTDomainProgressFilterInput
    $limit: Int
    $nextToken: String
    $sortDirection: ModelSortDirection
  ) {
    listIMTDomainProgresses(
      id: $id
      filter: $filter
      limit: $limit
      nextToken: $nextToken
      sortDirection: $sortDirection
    ) {
      items {
        id
        userId
        domainKey
        progress
        createdAt
        updatedAt
        owner
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const imtProgressByUserId = /* GraphQL */ `
  query ImtProgressByUserId(
    $userId: String!
    $sortDirection: ModelSortDirection
    $filter: ModelIMTDomainProgressFilterInput
    $limit: Int
    $nextToken: String
  ) {
    imtProgressByUserId(
      userId: $userId
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        userId
        domainKey
        progress
        createdAt
        updatedAt
        owner
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const iMTDomainProgressesByDomainKey = /* GraphQL */ `
  query IMTDomainProgressesByDomainKey(
    $domainKey: String!
    $sortDirection: ModelSortDirection
    $filter: ModelIMTDomainProgressFilterInput
    $limit: Int
    $nextToken: String
  ) {
    iMTDomainProgressesByDomainKey(
      domainKey: $domainKey
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        userId
        domainKey
        progress
        createdAt
        updatedAt
        owner
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const getCSTDomainProgress = /* GraphQL */ `
  query GetCSTDomainProgress($id: ID!) {
    getCSTDomainProgress(id: $id) {
      id
      userId
      domainKey
      progress
      createdAt
      updatedAt
      owner
      __typename
    }
  }
`;
export const listCSTDomainProgresses = /* GraphQL */ `
  query ListCSTDomainProgresses(
    $id: ID
    $filter: ModelCSTDomainProgressFilterInput
    $limit: Int
    $nextToken: String
    $sortDirection: ModelSortDirection
  ) {
    listCSTDomainProgresses(
      id: $id
      filter: $filter
      limit: $limit
      nextToken: $nextToken
      sortDirection: $sortDirection
    ) {
      items {
        id
        userId
        domainKey
        progress
        createdAt
        updatedAt
        owner
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const cstProgressByUserId = /* GraphQL */ `
  query CstProgressByUserId(
    $userId: String!
    $sortDirection: ModelSortDirection
    $filter: ModelCSTDomainProgressFilterInput
    $limit: Int
    $nextToken: String
  ) {
    cstProgressByUserId(
      userId: $userId
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        userId
        domainKey
        progress
        createdAt
        updatedAt
        owner
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const cSTDomainProgressesByDomainKey = /* GraphQL */ `
  query CSTDomainProgressesByDomainKey(
    $domainKey: String!
    $sortDirection: ModelSortDirection
    $filter: ModelCSTDomainProgressFilterInput
    $limit: Int
    $nextToken: String
  ) {
    cSTDomainProgressesByDomainKey(
      domainKey: $domainKey
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        userId
        domainKey
        progress
        createdAt
        updatedAt
        owner
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const getACCSDomainProgress = /* GraphQL */ `
  query GetACCSDomainProgress($id: ID!) {
    getACCSDomainProgress(id: $id) {
      id
      userId
      domainKey
      progress
      createdAt
      updatedAt
      owner
      __typename
    }
  }
`;
export const listACCSDomainProgresses = /* GraphQL */ `
  query ListACCSDomainProgresses(
    $id: ID
    $filter: ModelACCSDomainProgressFilterInput
    $limit: Int
    $nextToken: String
    $sortDirection: ModelSortDirection
  ) {
    listACCSDomainProgresses(
      id: $id
      filter: $filter
      limit: $limit
      nextToken: $nextToken
      sortDirection: $sortDirection
    ) {
      items {
        id
        userId
        domainKey
        progress
        createdAt
        updatedAt
        owner
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const accsProgressByUserId = /* GraphQL */ `
  query AccsProgressByUserId(
    $userId: String!
    $sortDirection: ModelSortDirection
    $filter: ModelACCSDomainProgressFilterInput
    $limit: Int
    $nextToken: String
  ) {
    accsProgressByUserId(
      userId: $userId
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        userId
        domainKey
        progress
        createdAt
        updatedAt
        owner
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const aCCSDomainProgressesByDomainKey = /* GraphQL */ `
  query ACCSDomainProgressesByDomainKey(
    $domainKey: String!
    $sortDirection: ModelSortDirection
    $filter: ModelACCSDomainProgressFilterInput
    $limit: Int
    $nextToken: String
  ) {
    aCCSDomainProgressesByDomainKey(
      domainKey: $domainKey
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        userId
        domainKey
        progress
        createdAt
        updatedAt
        owner
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const getNeuroSurgDomainProgress = /* GraphQL */ `
  query GetNeuroSurgDomainProgress($id: ID!) {
    getNeuroSurgDomainProgress(id: $id) {
      id
      userId
      domainKey
      progress
      createdAt
      updatedAt
      owner
      __typename
    }
  }
`;
export const listNeuroSurgDomainProgresses = /* GraphQL */ `
  query ListNeuroSurgDomainProgresses(
    $id: ID
    $filter: ModelNeuroSurgDomainProgressFilterInput
    $limit: Int
    $nextToken: String
    $sortDirection: ModelSortDirection
  ) {
    listNeuroSurgDomainProgresses(
      id: $id
      filter: $filter
      limit: $limit
      nextToken: $nextToken
      sortDirection: $sortDirection
    ) {
      items {
        id
        userId
        domainKey
        progress
        createdAt
        updatedAt
        owner
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const neuroSurgProgressByUserId = /* GraphQL */ `
  query NeuroSurgProgressByUserId(
    $userId: String!
    $sortDirection: ModelSortDirection
    $filter: ModelNeuroSurgDomainProgressFilterInput
    $limit: Int
    $nextToken: String
  ) {
    neuroSurgProgressByUserId(
      userId: $userId
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        userId
        domainKey
        progress
        createdAt
        updatedAt
        owner
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const neuroSurgDomainProgressesByDomainKey = /* GraphQL */ `
  query NeuroSurgDomainProgressesByDomainKey(
    $domainKey: String!
    $sortDirection: ModelSortDirection
    $filter: ModelNeuroSurgDomainProgressFilterInput
    $limit: Int
    $nextToken: String
  ) {
    neuroSurgDomainProgressesByDomainKey(
      domainKey: $domainKey
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        userId
        domainKey
        progress
        createdAt
        updatedAt
        owner
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const getRadiologyDomainProgress = /* GraphQL */ `
  query GetRadiologyDomainProgress($id: ID!) {
    getRadiologyDomainProgress(id: $id) {
      id
      userId
      domainKey
      progress
      createdAt
      updatedAt
      owner
      __typename
    }
  }
`;
export const listRadiologyDomainProgresses = /* GraphQL */ `
  query ListRadiologyDomainProgresses(
    $id: ID
    $filter: ModelRadiologyDomainProgressFilterInput
    $limit: Int
    $nextToken: String
    $sortDirection: ModelSortDirection
  ) {
    listRadiologyDomainProgresses(
      id: $id
      filter: $filter
      limit: $limit
      nextToken: $nextToken
      sortDirection: $sortDirection
    ) {
      items {
        id
        userId
        domainKey
        progress
        createdAt
        updatedAt
        owner
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const radiologyProgressByUserId = /* GraphQL */ `
  query RadiologyProgressByUserId(
    $userId: String!
    $sortDirection: ModelSortDirection
    $filter: ModelRadiologyDomainProgressFilterInput
    $limit: Int
    $nextToken: String
  ) {
    radiologyProgressByUserId(
      userId: $userId
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        userId
        domainKey
        progress
        createdAt
        updatedAt
        owner
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const radiologyDomainProgressesByDomainKey = /* GraphQL */ `
  query RadiologyDomainProgressesByDomainKey(
    $domainKey: String!
    $sortDirection: ModelSortDirection
    $filter: ModelRadiologyDomainProgressFilterInput
    $limit: Int
    $nextToken: String
  ) {
    radiologyDomainProgressesByDomainKey(
      domainKey: $domainKey
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        userId
        domainKey
        progress
        createdAt
        updatedAt
        owner
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const getCategoryPointsRecord = /* GraphQL */ `
  query GetCategoryPointsRecord($id: ID!) {
    getCategoryPointsRecord(id: $id) {
      id
      userId
      trainingPath
      categoriesData
      createdAt
      updatedAt
      owner
      __typename
    }
  }
`;
export const listCategoryPointsRecords = /* GraphQL */ `
  query ListCategoryPointsRecords(
    $id: ID
    $filter: ModelCategoryPointsRecordFilterInput
    $limit: Int
    $nextToken: String
    $sortDirection: ModelSortDirection
  ) {
    listCategoryPointsRecords(
      id: $id
      filter: $filter
      limit: $limit
      nextToken: $nextToken
      sortDirection: $sortDirection
    ) {
      items {
        id
        userId
        trainingPath
        categoriesData
        createdAt
        updatedAt
        owner
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const categoryPointsRecordsByUserId = /* GraphQL */ `
  query CategoryPointsRecordsByUserId(
    $userId: String!
    $sortDirection: ModelSortDirection
    $filter: ModelCategoryPointsRecordFilterInput
    $limit: Int
    $nextToken: String
  ) {
    categoryPointsRecordsByUserId(
      userId: $userId
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        userId
        trainingPath
        categoriesData
        createdAt
        updatedAt
        owner
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const categoryPointsRecordsByTrainingPath = /* GraphQL */ `
  query CategoryPointsRecordsByTrainingPath(
    $trainingPath: String!
    $sortDirection: ModelSortDirection
    $filter: ModelCategoryPointsRecordFilterInput
    $limit: Int
    $nextToken: String
  ) {
    categoryPointsRecordsByTrainingPath(
      trainingPath: $trainingPath
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        userId
        trainingPath
        categoriesData
        createdAt
        updatedAt
        owner
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const getPathfinderIMTDomainScore = /* GraphQL */ `
  query GetPathfinderIMTDomainScore($id: ID!) {
    getPathfinderIMTDomainScore(id: $id) {
      id
      userId
      domainKey
      progress
      createdAt
      updatedAt
      owner
      __typename
    }
  }
`;
export const listPathfinderIMTDomainScores = /* GraphQL */ `
  query ListPathfinderIMTDomainScores(
    $id: ID
    $filter: ModelPathfinderIMTDomainScoreFilterInput
    $limit: Int
    $nextToken: String
    $sortDirection: ModelSortDirection
  ) {
    listPathfinderIMTDomainScores(
      id: $id
      filter: $filter
      limit: $limit
      nextToken: $nextToken
      sortDirection: $sortDirection
    ) {
      items {
        id
        userId
        domainKey
        progress
        createdAt
        updatedAt
        owner
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const pathfinderImtScoresByUserId = /* GraphQL */ `
  query PathfinderImtScoresByUserId(
    $userId: String!
    $sortDirection: ModelSortDirection
    $filter: ModelPathfinderIMTDomainScoreFilterInput
    $limit: Int
    $nextToken: String
  ) {
    pathfinderImtScoresByUserId(
      userId: $userId
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        userId
        domainKey
        progress
        createdAt
        updatedAt
        owner
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const pathfinderIMTDomainScoresByDomainKey = /* GraphQL */ `
  query PathfinderIMTDomainScoresByDomainKey(
    $domainKey: String!
    $sortDirection: ModelSortDirection
    $filter: ModelPathfinderIMTDomainScoreFilterInput
    $limit: Int
    $nextToken: String
  ) {
    pathfinderIMTDomainScoresByDomainKey(
      domainKey: $domainKey
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        userId
        domainKey
        progress
        createdAt
        updatedAt
        owner
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const getPathfinderCSTDomainScore = /* GraphQL */ `
  query GetPathfinderCSTDomainScore($id: ID!) {
    getPathfinderCSTDomainScore(id: $id) {
      id
      userId
      domainKey
      progress
      createdAt
      updatedAt
      owner
      __typename
    }
  }
`;
export const listPathfinderCSTDomainScores = /* GraphQL */ `
  query ListPathfinderCSTDomainScores(
    $id: ID
    $filter: ModelPathfinderCSTDomainScoreFilterInput
    $limit: Int
    $nextToken: String
    $sortDirection: ModelSortDirection
  ) {
    listPathfinderCSTDomainScores(
      id: $id
      filter: $filter
      limit: $limit
      nextToken: $nextToken
      sortDirection: $sortDirection
    ) {
      items {
        id
        userId
        domainKey
        progress
        createdAt
        updatedAt
        owner
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const pathfinderCstScoresByUserId = /* GraphQL */ `
  query PathfinderCstScoresByUserId(
    $userId: String!
    $sortDirection: ModelSortDirection
    $filter: ModelPathfinderCSTDomainScoreFilterInput
    $limit: Int
    $nextToken: String
  ) {
    pathfinderCstScoresByUserId(
      userId: $userId
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        userId
        domainKey
        progress
        createdAt
        updatedAt
        owner
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const pathfinderCSTDomainScoresByDomainKey = /* GraphQL */ `
  query PathfinderCSTDomainScoresByDomainKey(
    $domainKey: String!
    $sortDirection: ModelSortDirection
    $filter: ModelPathfinderCSTDomainScoreFilterInput
    $limit: Int
    $nextToken: String
  ) {
    pathfinderCSTDomainScoresByDomainKey(
      domainKey: $domainKey
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        userId
        domainKey
        progress
        createdAt
        updatedAt
        owner
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const getPathfinderACCSDomainScore = /* GraphQL */ `
  query GetPathfinderACCSDomainScore($id: ID!) {
    getPathfinderACCSDomainScore(id: $id) {
      id
      userId
      domainKey
      progress
      createdAt
      updatedAt
      owner
      __typename
    }
  }
`;
export const listPathfinderACCSDomainScores = /* GraphQL */ `
  query ListPathfinderACCSDomainScores(
    $id: ID
    $filter: ModelPathfinderACCSDomainScoreFilterInput
    $limit: Int
    $nextToken: String
    $sortDirection: ModelSortDirection
  ) {
    listPathfinderACCSDomainScores(
      id: $id
      filter: $filter
      limit: $limit
      nextToken: $nextToken
      sortDirection: $sortDirection
    ) {
      items {
        id
        userId
        domainKey
        progress
        createdAt
        updatedAt
        owner
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const pathfinderAccsScoresByUserId = /* GraphQL */ `
  query PathfinderAccsScoresByUserId(
    $userId: String!
    $sortDirection: ModelSortDirection
    $filter: ModelPathfinderACCSDomainScoreFilterInput
    $limit: Int
    $nextToken: String
  ) {
    pathfinderAccsScoresByUserId(
      userId: $userId
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        userId
        domainKey
        progress
        createdAt
        updatedAt
        owner
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const pathfinderACCSDomainScoresByDomainKey = /* GraphQL */ `
  query PathfinderACCSDomainScoresByDomainKey(
    $domainKey: String!
    $sortDirection: ModelSortDirection
    $filter: ModelPathfinderACCSDomainScoreFilterInput
    $limit: Int
    $nextToken: String
  ) {
    pathfinderACCSDomainScoresByDomainKey(
      domainKey: $domainKey
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        userId
        domainKey
        progress
        createdAt
        updatedAt
        owner
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const getPathfinderNeuroSurgDomainScore = /* GraphQL */ `
  query GetPathfinderNeuroSurgDomainScore($id: ID!) {
    getPathfinderNeuroSurgDomainScore(id: $id) {
      id
      userId
      domainKey
      progress
      createdAt
      updatedAt
      owner
      __typename
    }
  }
`;
export const listPathfinderNeuroSurgDomainScores = /* GraphQL */ `
  query ListPathfinderNeuroSurgDomainScores(
    $id: ID
    $filter: ModelPathfinderNeuroSurgDomainScoreFilterInput
    $limit: Int
    $nextToken: String
    $sortDirection: ModelSortDirection
  ) {
    listPathfinderNeuroSurgDomainScores(
      id: $id
      filter: $filter
      limit: $limit
      nextToken: $nextToken
      sortDirection: $sortDirection
    ) {
      items {
        id
        userId
        domainKey
        progress
        createdAt
        updatedAt
        owner
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const pathfinderNeuroSurgScoresByUserId = /* GraphQL */ `
  query PathfinderNeuroSurgScoresByUserId(
    $userId: String!
    $sortDirection: ModelSortDirection
    $filter: ModelPathfinderNeuroSurgDomainScoreFilterInput
    $limit: Int
    $nextToken: String
  ) {
    pathfinderNeuroSurgScoresByUserId(
      userId: $userId
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        userId
        domainKey
        progress
        createdAt
        updatedAt
        owner
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const pathfinderNeuroSurgDomainScoresByDomainKey = /* GraphQL */ `
  query PathfinderNeuroSurgDomainScoresByDomainKey(
    $domainKey: String!
    $sortDirection: ModelSortDirection
    $filter: ModelPathfinderNeuroSurgDomainScoreFilterInput
    $limit: Int
    $nextToken: String
  ) {
    pathfinderNeuroSurgDomainScoresByDomainKey(
      domainKey: $domainKey
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        userId
        domainKey
        progress
        createdAt
        updatedAt
        owner
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const getPathfinderRadiologyDomainScore = /* GraphQL */ `
  query GetPathfinderRadiologyDomainScore($id: ID!) {
    getPathfinderRadiologyDomainScore(id: $id) {
      id
      userId
      domainKey
      progress
      createdAt
      updatedAt
      owner
      __typename
    }
  }
`;
export const listPathfinderRadiologyDomainScores = /* GraphQL */ `
  query ListPathfinderRadiologyDomainScores(
    $id: ID
    $filter: ModelPathfinderRadiologyDomainScoreFilterInput
    $limit: Int
    $nextToken: String
    $sortDirection: ModelSortDirection
  ) {
    listPathfinderRadiologyDomainScores(
      id: $id
      filter: $filter
      limit: $limit
      nextToken: $nextToken
      sortDirection: $sortDirection
    ) {
      items {
        id
        userId
        domainKey
        progress
        createdAt
        updatedAt
        owner
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const pathfinderRadiologyScoresByUserId = /* GraphQL */ `
  query PathfinderRadiologyScoresByUserId(
    $userId: String!
    $sortDirection: ModelSortDirection
    $filter: ModelPathfinderRadiologyDomainScoreFilterInput
    $limit: Int
    $nextToken: String
  ) {
    pathfinderRadiologyScoresByUserId(
      userId: $userId
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        userId
        domainKey
        progress
        createdAt
        updatedAt
        owner
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const pathfinderRadiologyDomainScoresByDomainKey = /* GraphQL */ `
  query PathfinderRadiologyDomainScoresByDomainKey(
    $domainKey: String!
    $sortDirection: ModelSortDirection
    $filter: ModelPathfinderRadiologyDomainScoreFilterInput
    $limit: Int
    $nextToken: String
  ) {
    pathfinderRadiologyDomainScoresByDomainKey(
      domainKey: $domainKey
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        userId
        domainKey
        progress
        createdAt
        updatedAt
        owner
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const getCalendarEvent = /* GraphQL */ `
  query GetCalendarEvent($id: ID!) {
    getCalendarEvent(id: $id) {
      id
      owner
      title
      description
      start
      end
      location
      eventType
      staff
      courseCode
      backgroundColor
      borderColor
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const listCalendarEvents = /* GraphQL */ `
  query ListCalendarEvents(
    $filter: ModelCalendarEventFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listCalendarEvents(filter: $filter, limit: $limit, nextToken: $nextToken) {
      items {
        id
        owner
        title
        description
        start
        end
        location
        eventType
        staff
        courseCode
        backgroundColor
        borderColor
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const calendarEventsByOwner = /* GraphQL */ `
  query CalendarEventsByOwner(
    $owner: String!
    $sortDirection: ModelSortDirection
    $filter: ModelCalendarEventFilterInput
    $limit: Int
    $nextToken: String
  ) {
    calendarEventsByOwner(
      owner: $owner
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        owner
        title
        description
        start
        end
        location
        eventType
        staff
        courseCode
        backgroundColor
        borderColor
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const getDailyActivity = /* GraphQL */ `
  query GetDailyActivity($id: ID!) {
    getDailyActivity(id: $id) {
      id
      owner
      date
      kind
      count
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const listDailyActivities = /* GraphQL */ `
  query ListDailyActivities(
    $id: ID
    $filter: ModelDailyActivityFilterInput
    $limit: Int
    $nextToken: String
    $sortDirection: ModelSortDirection
  ) {
    listDailyActivities(
      id: $id
      filter: $filter
      limit: $limit
      nextToken: $nextToken
      sortDirection: $sortDirection
    ) {
      items {
        id
        owner
        date
        kind
        count
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const dailyActivityByOwnerByDate = /* GraphQL */ `
  query DailyActivityByOwnerByDate(
    $owner: String!
    $date: ModelStringKeyConditionInput
    $sortDirection: ModelSortDirection
    $filter: ModelDailyActivityFilterInput
    $limit: Int
    $nextToken: String
  ) {
    dailyActivityByOwnerByDate(
      owner: $owner
      date: $date
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        owner
        date
        kind
        count
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
